var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ml-1" },
    [
      _c("LoadingOverlay", {
        attrs: { loading: _vm.loading, spinnerCentered: "" },
      }),
      _vm.initialProject
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.modalShown,
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
              isCareplanExist: _vm.isCareplanExist,
              initialData: _vm.initialProject,
              isEdit: true,
              currentEditTab: _vm.currentEditTab,
            },
            on: { closeDialog: _vm.hanldeCancel, close: _vm.handleClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }